import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconWorldPin } from "@tabler/icons-react";
import { RegionesTiendasDef } from "./RegionesTiendasDef";

export const RegionesTiendasIcon = IconWorldPin;
export const RegionesTiendasHelpText = '* Regiones de Tiendas.';

export class RegionesTiendas extends Entity<RegionesTiendasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RegionesTiendasDef(), parentKeys);
        this.Form = null;
        this.Title = "Regiones de Tiendas";
        this.HelpText = RegionesTiendasHelpText;
        this.Icon = RegionesTiendasIcon;
    }
}